<template>
    <div :class="`relative w-full ${passClasses}`" data-carousel="static" ref="primarySlider">
        <button title="Vollbild" class="p-2 bg-black/30 hover:bg-black/50 rounded-lg absolute z-[40] top-3 right-3"
            @click="modal.toggle()">
            <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 4H4m0 0v4m0-4 5 5m7-5h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5m7 5h4m0 0v-4m0 4-5-5" />
            </svg>
        </button>

        <!-- Carousel wrapper -->
        <div class="relative w-full aspect-video overflow-hidden rounded-lg bg-gray-200" style="max-height: inherit;">
            <div class="hidden duration-700 ease-in-out" data-carousel-item v-for="i in images" :key="i.url">
                <img :src="i.url" :alt="i.alt" :title="i.alt"
                    :class="`w-full h-full ${!keepAspectRatio || i.objectCover ? 'object-cover' : 'object-contain'}`">
            </div>
        </div>

        <!-- Slider controls -->
        <button type="button"
            class="absolute top-0 start-0 z-[35] flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
            @click="primarySlider.prev()">
            <span
                class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/30 group-hover:bg-black/50">
                <svg class="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M5 1 1 5l4 4" />
                </svg>
                <span class="sr-only">Nächstes</span>
            </span>
        </button>
        <button type="button"
            class="absolute top-0 end-0 z-[35] flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
            @click="primarySlider.next()">
            <span
                class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/30 group-hover:bg-black/50">
                <svg class="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 9 4-4-4-4" />
                </svg>
                <span class="sr-only">Vorheriges</span>
            </span>
        </button>
    </div>

    <div ref="modal" class="hidden fixed top-0 left-0 min-w-full h-screen z-[100] flex" tabindex="-1"
        aria-hidden="true">
        <div class="relative w-11/12 m-auto" data-carousel="static" ref="fullscreenSlider">
            <button title="Vollbild"
                class="p-2 bg-black/30 hover:bg-black/50 rounded-lg absolute z-[200] top-3 right-3"
                @click="modal.toggle()">
                <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18 17.94 6M18 18 6.06 6" />
                </svg>
            </button>

            <!-- Carousel wrapper -->
            <div class="relative w-full aspect-video overflow-hidden rounded-lg bg-gray-200"
                style="max-height: inherit;">
                <div class="hidden duration-700 ease-in-out" data-carousel-item v-for="i in images" :key="i.url">
                    <img :src="i.url" :alt="i.alt" :title="i.alt"
                        :class="`w-full h-full ${!keepAspectRatio ? 'object-cover' : 'object-contain'}`">
                </div>
            </div>

            <!-- Slider controls -->
            <button type="button"
                class="absolute top-0 start-0 z-[35] flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                @click="fullscreenSlider.prev()">
                <span
                    class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/30 group-hover:bg-black/50">
                    <svg class="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M5 1 1 5l4 4" />
                    </svg>
                    <span class="sr-only">Nächstes</span>
                </span>
            </button>
            <button type="button"
                class="absolute top-0 end-0 z-[35] flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                @click="fullscreenSlider.next()">
                <span
                    class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/30 group-hover:bg-black/50">
                    <svg class="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 9 4-4-4-4" />
                    </svg>
                    <span class="sr-only">Vorheriges</span>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import { initModals, initCarousels, Carousel, Modal } from 'flowbite'

export default {
    name: "gallery",
    props: {
        images: Array,
        keepAspectRatio: Boolean,
        passClasses: String,
    },
    data() {
        return {
            primarySlider: null,
            fullscreenSlider: null,
            modal: null,
        }
    },
    mounted() {
        initCarousels();
        initModals();

        const _modal = this.$refs.modal;

        const modelOptions = {
            placement: 'top-left',
            closable: true,
            onShow: () => {
                window.lenis.stop();
            },
            onHide: () => {
                window.lenis.start();
            }
        };

        const modalInstanceOptions = {
            override: true
        };

        this.modal = new Modal(_modal, modelOptions, modalInstanceOptions);

        const _primarySlider = this.$refs.primarySlider;
        const _fullscreenSlider = this.$refs.fullscreenSlider;

        const _primaryItems = [..._primarySlider.querySelectorAll('[data-carousel-item]')].map((i, n) => { return { position: n, el: i } });
        const _fullscreenItems = [..._fullscreenSlider.querySelectorAll('[data-carousel-item]')].map((i, n) => { return { position: n, el: i } });

        const _primaryOptions = {
            defaultPosition: 0,
            onChange: (e) => {
                this.fullscreenSlider?.slideTo(e?.getActiveItem()?.position);
            }
        }

        const _fullscreenOptions = {
            defaultPosition: 0,
        }

        const _primaryInstanceOptions = {
            override: true
        };

        const _fullscreenInstanceOptions = {
            override: true
        };

        this.primarySlider = new Carousel(_primarySlider, _primaryItems, _primaryOptions, _primaryInstanceOptions);
        this.fullscreenSlider = new Carousel(_fullscreenSlider, _fullscreenItems, _fullscreenOptions, _fullscreenInstanceOptions);
    },
    created() {
    }
}
</script>